export function getUniqueDirectoriesPaths(files: File[]): string[] {
  const directories = new Set<string>();

  for (const file of files) {
    file.webkitRelativePath
      .split('/')
      .slice(0, -1)
      .reduce((path, part) => {
        const current = path ? `${path}/${part}` : part;
        directories.add(current);
        return current;
      }, '');
  }

  return Array.from(directories).sort(
    (a, b) => a.split('/').length - b.split('/').length
  );
}

/**
 * Groups directory paths by their depth in the hierarchy.
 *
 * Depth is determined by the number of segments in the path (separated by '/').
 * Returns an object where the key is the depth level and the value is an array
 * of directory paths at that level.
 *
 * @param dirs - Array of directory paths (e.g., ['a', 'a/b', 'a/b/c', 'x/y'])
 * @returns Object grouped by depth level
 *
 * @example
 * groupDirectoriesByDepth(['a', 'a/b', 'a/b/c', 'x', 'x/y'])
 * // Returns:
 * // {
 * //   1: ['a', 'x'],           // directories at level 1
 * //   2: ['a/b', 'x/y'],       // directories at level 2
 * //   3: ['a/b/c']             // directories at level 3
 * // }
 */

export function groupDirectoriesByDepth(
  dirs: string[]
): Record<number, string[]> {
  return dirs.reduce<Record<number, string[]>>((acc, dir) => {
    const depth = dir.split('/').length;
    if (!acc[depth]) {
      acc[depth] = [];
    }
    acc[depth].push(dir);
    return acc;
  }, {});
}
